import {IServiceDetail, IServiceDetailListItem, ServiceDetailResponseType} from "@/entity/services/serviceDetail.types";

export default class ServiceDetail implements IServiceDetail {
    total: number;
    data: IServiceDetailListItem[] = [];
    constructor(data: ServiceDetailResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}